// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__14W5l","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1UsrT"};